export default __webpack_public_path__ + "static/media/LeftHandBatter.5f06a49b.png";